import axios from 'axios'
import router from '@/router/router'
var jwtDecode = require('jwt-decode')

const state = {
    authToken: localStorage.getItem('token'),
    authRefreshToken: null,
    authUserId: null,
    authRole: null,
    authActive: null, //Статус польщователя - актиаен/неактивен
    authTokenExp: null
};

const getters = {
    authToken: state => {
        return state.authToken
    },
    authRefreshToken: state => {
        return state.authRefreshToken
    },
    authRole: state => {
        return state.authRole
    },
    authActive: state => {
        return state.authActive
    },
    authTokenExp: state => {
        return state.authTokenExp
    },
    authUserId: state => {
        return state.authUserId
    }
};

const mutations = {
    authToken: (state, token) => {
        return state.authToken = token
    },
    authRefreshToken: (state, refreshToken) => {
        return state.authRefreshToken = refreshToken
    },
    authRole: (state, role) => {
        return state.authRole = role
    },
    authActive: (state, active) => {
        return state.authActive = active
    },
    authTokenExp: (state, exp) => {
        return state.authTokenExp = exp
    },
    authUserId: (state, id) => {
        return state.authUserId = id
    }
};

const actions = {
    login({commit, dispatch}, authData) {
        axios.post('login', {
            email: authData.email,
            password: authData.password
        })
        .then(response => {
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('refresh_token', response.data.refresh_token)

            location.replace('/admin')

            dispatch('authUseToken')
        })
        .catch(err => {
            console.error('Ошибка авторизации: ', err)
            dispatch('modalNotificationMessageOpen', ['Ошибка авторизации'])
        })
    },
    logOut() {
        localStorage.removeItem('token')
        window.location.assign('/')
    },
    authUseToken({commit, getters}) {
    //Разбираем токен
        if (localStorage.getItem('token')) {
            commit('authToken', localStorage.getItem('token'))
            commit('authUserId', jwtDecode(localStorage.getItem('token')).id)
            commit('authRole', JSON.parse(decodeURIComponent(jwtDecode(localStorage.getItem('token')).role)))
            commit('authActive', jwtDecode(localStorage.getItem('token')).status)
            commit('authTokenExp', jwtDecode(localStorage.getItem('token')).exp * 1000)
        }
    },
    authUseRefreshToken({commit}) {
    //Берем рефреш токен из хранилища
        if (localStorage.getItem('refresh_token')) {
            commit('authRefreshToken', localStorage.getItem('refresh_token'))
        }
    },
    authRefreshToken({getters, dispatch}) {
    //Обновляем токен
        dispatch('authUseRefreshToken')
            axios({
                method: 'POST',
                url: 'refresh',
                data: {
                    refresh_token: getters.authRefreshToken
                }
            })
            .then(response => {
                console.log('refresh ok', response)
                
                localStorage.setItem('token', response.data.token)
                localStorage.setItem('refresh_token', response.data.refresh_token)
                dispatch('authUseToken')
            })
            .then(() => {
                dispatch('authUseToken')
            })
            .catch(err => {
                console.log('Ошибка отправки refresh token: ', err.response)
            })
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}